













import {Component, Prop, Vue} from 'vue-property-decorator';
import loadingDataDark from '../animations/loading-dark.json';
import loadingDataLight from '../animations/loading-light.json';
import Lottie from 'vue-lottie-web';

@Component({
	components: {
		Lottie: Lottie
	}
})
export default class LoadingIndicator extends Vue {
	@Prop() private type!: 'dark' | 'light';

	lottieInstance: any;
	lottieDataDark: any = loadingDataDark;
	lottieDataLight: any = loadingDataLight;

	get lottieData() {
		return this.type === 'dark' || this.type === undefined ? this.lottieDataDark : this.lottieDataLight;
	}

	getLottieInstance(lottieInstance: any) {
		this.lottieInstance = lottieInstance;
	}
}
